// 搜索结果点击下载下方弹出推荐应用
import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardDReco.module.less';
import { getSoftType } from '../../utils/utils';

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const handleSoftCard = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfo.source_p,
          source_pp: logInfo.source_pp,
          cardName: 'SoftCardDReco',
          softid: soft?.packageName,
          softType: getSoftType(soft),
        },
        param3: soft.bizInfo,
      }),
    );
    // 跳转页面前更改source为source_p，改source_p为source_pp
    dispatch(
      logPostInfo({
        source_p: logInfo.source,
        source_pp: logInfo.source_p,
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.soft_card_img_box}
        to={{
          pathname:
            soft.androidType === '1'
              ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
                  '{}'}?isSearch=true`
              : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
        }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
      </Link>
      <div className={styles.soft_card_box}>
        <Link
          to={{
            pathname:
              soft.androidType === '1'
                ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
                    '{}'}?isSearch=true`
                : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div
            className={styles.soft_card_title}
            dangerouslySetInnerHTML={{ __html: soft.softName }}
            title={soft.softName}
          />
          <div className={styles.soft_card_desc}>{soft.downloadCount || 0}安装</div>
        </Link>
        <div
          className={styles.soft_card_opt}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {soft.androidType === '1' ? (
            <ApkButton
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          ) : (
            <Button
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          )}
        </div>
      </div>
    </div>
  );
});
